import type { PixelSprite } from '../types.js';
const variant0: PixelSprite = {
  layers: [
    {
      paint: 'boulder',
      d: 'M-0.5,-12.5h1v0.5h-1zM-0.5,-12h1.5v0.5h-1.5zM0.5,-11.5h0.5v1h-0.5zM1.5,-11.5h0.5v0.5h-0.5zM-0.5,-11h0.5v0.5h-0.5zM2,-11h0.5v0.5h-0.5zM-0.5,-10.5h1v0.5h-1zM2,-10.5h1v0.5h-1zM1.5,-10h0.5v0.5h-0.5zM2.5,-10h1.5v1h-1.5zM3,-9h1.5v1h-1.5zM3.5,-8h1.5v3h-1.5zM4,-5h1v1h-1zM3.5,-4h1.5v0.5h-1.5zM-4.5,-3.5h1.5v0.5h-1.5zM3,-3.5h2v0.5h-2zM3.5,-3h1.5v3h-1.5zM-5.5,0h1v0.5h-1zM-5.5,0.5h3.5v0.5h-3.5zM2.5,0.5h3v0.5h-3zM-5,1h10.5v0.5h-10.5zM-2.5,1.5h5.5v0.5h-5.5z',
    },
    {
      paint: 'rock',
      d: 'M-1,-12h0.5v0.5h-0.5zM1,-11.5h0.5v0.5h-0.5zM1,-11h1v0.5h-1zM-1,-10.5h0.5v0.5h-0.5zM0.5,-10.5h1.5v0.5h-1.5zM-4,-10h0.5v0.5h-0.5zM-1.5,-10h3v0.5h-3zM2,-10h0.5v0.5h-0.5zM-2.5,-9.5h1.5v0.5h-1.5zM1,-9.5h1.5v0.5h-1.5zM-3,-9h1v0.5h-1zM2,-9h1v1h-1zM-3.5,-8.5h1.5v0.5h-1.5zM-3.5,-8h1v1.5h-1zM2.5,-8h1v4.5h-1zM-4.5,-6.5h2v0.5h-2zM-4,-6h1.5v1h-1.5zM-3,-5h0.5v1h-0.5zM-4,-4.5h0.5v0.5h-0.5zM-4,-4h1.5v0.5h-1.5zM-3,-3.5h0.5v0.5h-0.5zM2.5,-3.5h0.5v0.5h-0.5zM-3.5,-3h1v2h-1zM2.5,-3h1v2.5h-1zM-4,-1h1.5v0.5h-1.5zM-5,-0.5h0.5v0.5h-0.5zM-3.5,-0.5h7v0.5h-7zM-4.5,0h8.5v0.5h-8.5zM5,0h0.5v0.5h-0.5zM-2,0.5h4.5v0.5h-4.5z',
    },
    {
      paint: 'epicMarble',
      d: 'M-2,-11.5h1.5v0.5h-1.5zM-2.5,-11h2v0.5h-2zM-3.5,-10.5h2.5v0.5h-2.5zM-3.5,-10h2v0.5h-2zM-4,-9.5h1.5v0.5h-1.5zM-4.5,-9h1.5v0.5h-1.5zM-4.5,-8.5h1v0.5h-1zM-5,-8h1.5v1.5h-1.5zM-5,-6.5h0.5v0.5h-0.5zM-5,-6h1v2.5h-1zM-5,-3.5h0.5v0.5h-0.5zM-5,-3h1.5v2h-1.5zM-5,-1h1v0.5h-1z',
    },
    {
      paint: 'epicPortal',
      d: 'M-0.5,-11.5h1v0.5h-1zM0,-11h0.5v0.5h-0.5zM-1,-9.5h2v0.5h-2zM-2,-9h4v1h-4zM-2.5,-8h1.5v0.5h-1.5zM1,-8h1.5v0.5h-1.5zM-2.5,-7.5h1v1h-1zM1.5,-7.5h1v1.5h-1zM-2.5,-6.5h0.5v2.5h-0.5zM2,-6h0.5v1.5h-0.5zM-4,-5h1v0.5h-1zM3.5,-5h0.5v1h-0.5zM-3.5,-4.5h0.5v0.5h-0.5zM1.5,-4.5h1v1.5h-1zM-2.5,-4h1v1h-1zM-2.5,-3h1.5v0.5h-1.5zM1,-3h1.5v0.5h-1.5zM-2.5,-2.5h2v0.5h-2zM0.5,-2.5h2v0.5h-2zM-2.5,-2h5v1.5h-5z',
    },
    {
      paint: 'epicCrystal',
      d: 'M-1,-8h2v0.5h-2zM-1.5,-7.5h3v1h-3zM-2,-6.5h3.5v0.5h-3.5zM-1.5,-6h3.5v1.5h-3.5zM-2,-4.5h0.5v0.5h-0.5zM-1,-4.5h2.5v0.5h-2.5zM-0.5,-4h2v0.5h-2zM-1.5,-3.5h0.5v0.5h-0.5zM0.5,-3.5h1v0.5h-1zM-1,-3h2v0.5h-2zM-0.5,-2.5h1v0.5h-1z',
    },
    {
      paint: 'snowCap',
      d: 'M-2,-6h0.5v1.5h-0.5zM-1.5,-4.5h0.5v0.5h-0.5zM-1.5,-4h1v0.5h-1zM-1,-3.5h1.5v0.5h-1.5z',
    },
    { paint: 'moss', d: 'M-4.5,-0.5h1v0.5h-1zM4,0h1v0.5h-1z' },
  ],
  pixels: 501,
};
export const sprites: readonly PixelSprite[] = [variant0];
